import axios from 'axios';

// In production (Vercel): /api  — proxied by vercel.json to Railway backend (no CORS)
// In local dev:           http://localhost:8000/api
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach auth token automatically on every request (chatroom auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('chat_token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

// Categories
export const getCategories = () => api.get('/categories/');
export const getCategory = (id) => api.get(`/categories/${id}/`);

// Subcategories
export const getSubcategories = (categoryId = null) => {
  const url = categoryId ? `/subcategories/?category=${categoryId}` : '/subcategories/';
  return api.get(url);
};

// Archive Items
export const getArchiveItems = (params = {}) => api.get('/archive-items/', { params });
export const getArchiveItem = (id) => api.get(`/archive-items/${id}/`);
export const getArchiveItemsByCategory = (categoryId) => 
  api.get(`/archive-items/by_category/?category_id=${categoryId}`);

// People
export const getPeople = (params = {}) => api.get('/people/', { params });
export const getPerson = (id) => api.get(`/people/${id}/`);
export const getPeopleBySubcategory = (subcategoryId) => 
  api.get(`/people/by_subcategory/?subcategory_id=${subcategoryId}`);

// Person Suggestions
export const getPersonSuggestions = (personId = null) => {
  const url = personId ? `/person-suggestions/by_person/?person_id=${personId}` : '/person-suggestions/';
  return api.get(url);
};

export const submitPersonSuggestion = (data) => {
  const formData = new FormData();
  
  // Append all fields
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
      formData.append(key, data[key]);
    }
  });
  
  return api.post('/person-suggestions/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


// Locations
export const getLocations = (params = {}) => api.get('/locations/', { params });
export const getLocation = (id) => api.get(`/locations/${id}/`);

// News
export const getNews = (params = {}) => api.get('/news/', { params });
export const getNewsItem = (id) => api.get(`/news/${id}/`);
export const getRecentNews = (limit = 5) => api.get(`/news/recent/?limit=${limit}`);

// Contributions
export const submitContribution = (data) => {
  const formData = new FormData();
  
  // Append all fields
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
      formData.append(key, data[key]);
    }
  });
  
  return api.post('/contributions/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getContributions = (params = {}) => api.get('/contributions/', { params });
export const getPendingContributions = () => api.get('/contributions/pending/');

// Cultural Sections (top-level groupings — mirrors Categories for people)
export const getCulturalSections = (params = {}) => api.get('/cultural-sections/', { params });
export const getCulturalSection   = (id)          => api.get(`/cultural-sections/${id}/`);

// Cultural Content
export const getCulturalContent       = (params = {}) => api.get('/cultural-content/', { params });
export const getCulturalContentByType = (type)        => api.get(`/cultural-content/by_type/?type=${type}`);
export const getCulturalContentItem   = (id)          => api.get(`/cultural-content/${id}/`);
export const getCulturalContentTypes  = ()            => api.get('/cultural-content/types/');

export default api;

// Global Search
export const globalSearch = (query) => api.get(`/search/?q=${encodeURIComponent(query)}`);

// Gbongan AI Chatbot
export const olufiChat = (message) => api.post('/olufi/', { message });

// Hero Images
export const getHeroImages = () => api.get('/hero-images/');
